import PropTypes from 'prop-types';

/**
 * Selectable rows inside a Popover — the plain-list case that needs no header or footer.
 *
 * Use Menu.Item for actions and options, Menu.Label to caption a group and Menu.Separator between
 * groups. Anything richer belongs in Panel.Header / Panel.Body instead.
 */
const Menu = ({ children }) => <div className="py-1">{children}</div>;

const ITEM_TONES = {
	default: 'text-text hover:bg-bgBase-300',
	danger: 'text-warning-700 hover:bg-warning-200',
};

const MenuItem = ({
	children,
	onClick,
	selected = false,
	disabled = false,
	icon: Icon,
	trailing,
	tone = 'default',
}) => (
	<button
		type="button"
		onClick={onClick}
		disabled={disabled}
		role="menuitem"
		className={`w-full text-left px-3.5 py-2 text-sm flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
			selected ? 'bg-primary-100 text-primary-700' : ITEM_TONES[tone]
		}`}
	>
		{Icon && <Icon className="w-4 h-4 flex-shrink-0" />}
		<span className="truncate flex-1">{children}</span>
		{trailing && <span className="flex-shrink-0 text-xs text-bgBase-800">{trailing}</span>}
	</button>
);

MenuItem.propTypes = {
	children: PropTypes.node,
	onClick: PropTypes.func,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	icon: PropTypes.elementType,
	trailing: PropTypes.node,
	tone: PropTypes.oneOf(['default', 'danger']),
};

const MenuLabel = ({ children }) => <div className="px-3.5 py-1.5 text-xs-head text-bgBase-800">{children}</div>;

MenuLabel.propTypes = { children: PropTypes.node };

const MenuSeparator = () => <div className="h-px bg-bgBase-400 my-1" />;

const MenuEmpty = ({ children = 'Keine Einträge' }) => (
	<div className="px-3.5 py-6 text-sm text-bgBase-800 text-center">{children}</div>
);

MenuEmpty.propTypes = { children: PropTypes.node };

Menu.propTypes = { children: PropTypes.node };

Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Separator = MenuSeparator;
Menu.Empty = MenuEmpty;

export default Menu;
